export default __webpack_public_path__ + "static/media/venda-assegurada.2b6a9e83.jpg";